import { render, staticRenderFns } from "./AppSunset.vue?vue&type=template&id=129f20e1&scoped=true"
import script from "./AppSunset.vue?vue&type=script&lang=js"
export * from "./AppSunset.vue?vue&type=script&lang=js"
import style0 from "./AppSunset.vue?vue&type=style&index=0&id=129f20e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129f20e1",
  null
  
)

export default component.exports